import React,{FunctionComponent, useState} from 'react'
import { copy } from '../../utils/copy'
import {ButtonShare} from './style'
import {CustomIcon} from '../CustomIcon'
import { setTimeout } from 'timers'
import { language } from '../../utils/language'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers/index'

type TypesProps = {
    url:string,
    color: string,
    outlined?: boolean
}

export const  Share:FunctionComponent<TypesProps> = ({url,color, outlined = false}) => {
    let navigator: any;
    navigator = window.navigator

  //const [open, setOpen] = useState(false)
    const [spam, setSpam] = useState(false)
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);

    const onShare = (urlOnShare:string) => {
        navigator.share({
          title: 'ePayco Vende',
          url: urlOnShare,

        })
    }

    const onCopy = (urlOnCopy:string) => {
        copy(urlOnCopy)
    }

    const handleShare = (urlShare:string) => {
        setSpam(true)
        if (navigator.share) {
          onShare(urlShare)
        } else {
          onCopy(urlShare)
        }
        setTimeout(() => {
          setSpam(false)
        }, 1000);
      }

    return (
        <>
          <ButtonShare onClick={() => handleShare(url)} color={color} outlined={outlined} spam={spam}>
            <CustomIcon color={color} hover={outlined} type="share" />
            <span>{language[homeState.default_language]["urlCopy"]}</span>
          </ButtonShare>
        </>
    )
}
